export default __webpack_public_path__ + "static/media/geb.0d2c4791.svg";